export class Company {
  Name: string;
  Address: string;
  AddressNumber: string;
  PostalCode: string;
  City: string;
  CountryId: string;
  VATNumber: string;
  Phone: string;
  Email: string;
  Iban: string;
  UserField1: string;
  UserField2: string;
  UserField3: string;
  UserField4: string;
  UserField5: string;
  UserField6: string;
  UserField7: string;
  UserField8: string;
  UserField9: string;
}
